import { useStore } from '@xyflow/react'
import { FlowTypes } from 'v2/types'
import { useFlowStore } from '../store'
import { FlowNodeTypes } from '../types'
import { isAiAgentV2Type } from '../utils/ai-agent-v29'

export const useHasSmsNode = () => {
  const currentFlowType = useFlowStore((state) => state.currentFlowType)
  const hasSmsNode = useStore((state) =>
    state.nodes.some((node) => {
      const config = (node.data as { config?: { channel?: string } })?.config
      return (
        (node.type === FlowNodeTypes.agent_preset_conversation && config?.channel === 'message') ||
        (isAiAgentV2Type(node.type) && config?.channel === 'message') ||
        node.type === FlowNodeTypes.send_message ||
        node.type === FlowNodeTypes.ai_agent_message ||
        node.type === FlowNodeTypes.message_conversation
      )
    }),
  )

  return (
    currentFlowType === FlowTypes.incoming_sms ||
    currentFlowType === FlowTypes.outgoing_sms ||
    hasSmsNode
  )
}

export const useHasWhatsappNode = () => {
  const currentFlowType = useFlowStore((state) => state.currentFlowType)
  const hasWhatsappNode = useStore((state) =>
    state.nodes.some((node) => {
      const config = (node.data as { config?: { channel?: string } })?.config
      return (
        (node.type === FlowNodeTypes.agent_preset_conversation && config?.channel === 'whatsapp') ||
        (isAiAgentV2Type(node.type) && config?.channel === 'whatsapp') ||
        node.type === FlowNodeTypes.send_whatsapp ||
        node.type === FlowNodeTypes.ai_agent_whatsapp ||
        node.type === FlowNodeTypes.whatsapp_conversation
      )
    }),
  )

  return (
    currentFlowType === FlowTypes.incoming_whatsapp ||
    currentFlowType === FlowTypes.outgoing_whatsapp ||
    hasWhatsappNode
  )
}
